import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-home',
  templateUrl: './support-home.component.html',
  styleUrls: ['./support-home.component.css']
})
export class SupportHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
